export enum TargetEnum {
  CURRENT_WINDOW = '_self',
  NEW_WINDOW = '_blank',
  PARENT_FRAME = '_parent',
  FULL_WINDOW_BODY = '_top',
}
